import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "referencesGrid" }
const _hoisted_2 = ["onClick"]

import FormButton from '@/components/common/button/FormButton.vue';
import CustomModal from '@/components/common/modal/CustomModal.vue';
import OriginalReference from '@/components/common/original-reference/OriginalReference.vue';
import { Reference } from '@/models/doc-review';
import { useReferenceSelectionStore } from '@/stores/useReferenceSelectionStore';
import { OfficeUtils } from '@/utils/office.utils';
import { v4 as uuidv4 } from 'uuid';
import { computed, ref } from 'vue';

interface Props {
  referencedParagraphs: Reference[];
  onResetReview: () => void;
  renderId: string;
}

interface ProcessedReference {
  paragraphIndex: number;
  endParagraphIndex?: number;
  paragraphsConents: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReferenceDots',
  props: {
    referencedParagraphs: {},
    onResetReview: { type: Function },
    renderId: {}
  },
  setup(__props: any) {

const props = __props;

const paragraphsConents = ref<Record<string, string>>({});
const showModal = ref(false);
const referenceStore = useReferenceSelectionStore();

const processedReferences = computed<ProcessedReference[]>(() => {
  if (!props.referencedParagraphs || props.referencedParagraphs.length === 0) {
    return [];
  }

  const sorted = [...props.referencedParagraphs].sort(
    (a, b) => a.paragraphIndex - b.paragraphIndex
  );

  const result: ProcessedReference[] = [];
  let group: ProcessedReference | null = null;

  for (const refItem of sorted) {
    if (!group) {
      group = {
        paragraphIndex: refItem.paragraphIndex,
        paragraphsConents: [refItem.paragraphContent]
      };
    } else {
      const lastIndex: number | undefined =
        group.endParagraphIndex ?? group.paragraphIndex;
      if (refItem.paragraphIndex === lastIndex + 1) {
        group.paragraphsConents.push(refItem.paragraphContent);
        group.endParagraphIndex = refItem.paragraphIndex;
      } else {
        result.push(group);
        group = {
          paragraphIndex: refItem.paragraphIndex,
          paragraphsConents: [refItem.paragraphContent]
        };
      }
    }
  }
  if (group) result.push(group);

  return result;
});

const onDotClick = async (
  reference: ProcessedReference,
  arrayIndex: number
) => {
  referenceStore.selectReference(
    props.renderId,
    arrayIndex,
    reference.paragraphsConents
  );
  const paragraphs = await OfficeUtils.getDocumentParagraphs();
  paragraphsConents.value = {};

  const start = reference.paragraphIndex;
  const end = reference.endParagraphIndex ?? reference.paragraphIndex;
  const documentParagraphs: string[] = [];
  for (let i = start; i <= end; i++) {
    documentParagraphs.push(paragraphs[i]);
  }

  const mismatchedParagraphs = documentParagraphs.filter(
    (p) => !reference.paragraphsConents.includes(p)
  );

  if (mismatchedParagraphs.length) {
    mismatchedParagraphs.forEach((paragraph) => {
      paragraphsConents.value[uuidv4()] = paragraph;
    });
    showModal.value = true;
  } else {
    OfficeUtils.scrollToAndSelectParagraph(start, end);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedReferences.value, (reference, arrayIndex) => {
      return (_openBlock(), _createElementBlock("p", {
        key: reference.paragraphIndex,
        onClick: ($event: any) => (onDotClick(reference, arrayIndex)),
        class: _normalizeClass(["referenceDot", {
        active:
          _unref(referenceStore).selectedReference?.renderId === _ctx.renderId &&
          _unref(referenceStore).selectedReference?.index === arrayIndex
      }])
      }, _toDisplayString(arrayIndex + 1), 11, _hoisted_2))
    }), 128)),
    _createVNode(CustomModal, {
      show: showModal.value,
      closeOnOutsideClick: true,
      "onUpdate:show": _cache[1] || (_cache[1] = (val) => (showModal.value = val))
    }, {
      "left-button": _withCtx(() => [
        _createVNode(FormButton, {
          label: _ctx.$t('reviewing.reference_dots.re_start_conversation'),
          onClick: _cache[0] || (_cache[0] = 
            () => {
              _ctx.onResetReview();
              showModal.value = false;
            }
          )
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createVNode(OriginalReference, { "original-paragraphs": paragraphsConents.value }, null, 8, ["original-paragraphs"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})